<template>
  <v-card class="mb-4 pa-4">
    <p class="text-h6 secondary--text">Etapas del contrato</p>
    <v-progress-linear
      :value="porcentaje"
      rounded
      color="secondary"
      height="30"
      :dark="porcentaje >= 50"
    >
      <strong class="styleText white--text"> {{ porcentaje }}% </strong>
    </v-progress-linear>
    <div class="my-6">
      <etapas-list hideFilters />
    </div>
  </v-card>
</template>

<script>
import EtapasList from "../EtapaSeguimientoComponent.vue";
export default {
  name: "EtapasContratoComponent",
  components: { EtapasList },
  data: () => ({
    porcentajeSeguimiento: 60,
  }),
  computed: {
    porcentaje() {
      return (this.porcentajeSeguimiento * 100).toFixed(2);
    },
  },
  methods: {
    async getProgresoSeguimiento() {
      const { status, data } =
        await this.services.ContratoService.getProgresoEtapasSeguimiento(
          this.$route.params.idContrato
        );
      if (status == 200) {
        this.porcentajeSeguimiento = data.progreso;
      }
    },
  },
  created() {
    this.getProgresoSeguimiento();
  },
};
</script>
